import { ColDef } from 'ag-grid-enterprise';
import { OptionCell } from './OptionCell';

export type Invite = {
  email: string;
  invited: Date;
  role: string;
  status: string;
  handleRevoke: () => void;
  options?: string;
};

export const colDefsInvitesTable: ColDef<Invite>[] = [
  {
    field: 'email',
    headerName: 'Email',
    sortable: true,
    filter: true,
    type: 'w200',
    autoHeight: true,
    cellClass: 'flex align-items-center justify-content-left',
    wrapText: true,
  },
  {
    field: 'invited',
    headerName: 'Invited',
    sortable: true,
    cellClass: 'flex align-items-center justify-content-left',
    type: 'w120',
    filter: true,
  },
  {
    field: 'role',
    headerName: 'Role',
    cellClass: 'flex align-items-center justify-content-left capitalize',
    type: 'w200',
    sortable: true,
    filter: true,
  },
  {
    field: 'status',
    headerName: 'Status',
    cellClass: 'flex align-items-center justify-content-left capitalize',
    type: 'w200',
    sortable: true,
    filter: true,
  },
  {
    field: 'options',
    headerName: '',
    cellRenderer: OptionCell,
    cellClass: 'flex align-items-center justify-content-center',
    type: 'w200',
    sortable: true,
    filter: true,
  },
];
